module.exports.value = 1;


/*****************
 ** WEBPACK FOOTER
 ** ./runtime/module-caching/singluar.js
 ** module id = 1
 ** module chunks = 0
 **/